/* tslint:disable */
/* eslint-disable */
export enum MalpracticeType {
  Claims = 'Claims',
  Occurrence = 'Occurrence',
  Unknown = 'Unknown'
}
